module.exports = __webpack_public_path__ + "static/media/seta-esquerda.7f9ab628.svg";